import { hotTopics } from "@/mocks/index";

function DeltaIcon({ delta }: { delta: "up" | "down" | "new" | "keep" }) {
  if (delta === "up")
    return (
      <span className="inline-flex items-center text-red-400">
        <i className="ri-arrow-up-line text-sm" />
      </span>
    );
  if (delta === "down")
    return (
      <span className="inline-flex items-center text-stone-500">
        <i className="ri-arrow-down-line text-sm" />
      </span>
    );
  if (delta === "new")
    return (
      <span className="whitespace-nowrap rounded-md bg-amber-500 px-1.5 py-0.5 text-[10px] font-bold text-stone-950">
        新
      </span>
    );
  return (
    <span className="inline-flex items-center text-stone-500">
      <i className="ri-arrow-right-line text-sm" />
    </span>
  );
}

const rankColor = (rank: number) => {
  if (rank === 1) return "bg-gradient-to-b from-orange-500 to-amber-400 text-stone-950";
  if (rank === 2) return "bg-orange-500/70 text-white";
  if (rank === 3) return "bg-amber-500/60 text-stone-950";
  return "bg-white/10 text-stone-300";
};

export default function RankingSection() {
  return (
    <section id="ranking" className="scroll-mt-20 bg-stone-950 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          {/* 左：说明 + 文案 */}
          <div className="lg:col-span-4">
            <div className="mb-3 flex items-center gap-2">
              <i className="ri-bar-chart-2-line text-2xl text-orange-500" />
              <span className="text-xs font-semibold uppercase tracking-widest text-orange-400">HOT BOARD</span>
            </div>
            <h2 className="text-2xl font-black text-white md:text-4xl">热议榜 · 弹幕爆梗</h2>
            <p className="mt-4 text-sm leading-relaxed text-stone-400 md:text-base">
              实时热度综合弹幕量、连麦参与度与反应视频传播速度计算。冲上来的话题，往往已经有一整排直播间开好陪看位等你进场。
            </p>

            <div className="mt-7 rounded-2xl border border-white/10 bg-white/[0.03] p-5">
              <p className="text-sm font-semibold text-white">想蹲的后续没上榜？</p>
              <p className="mt-2 text-sm leading-relaxed text-stone-400">
                刷到有意思的现场，别忘了回来发一条弹幕报个点，评论区的二创跟更得快。
              </p>
              <a
                href="#now"
                className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-orange-500 px-5 py-2.5 text-sm font-semibold text-stone-950 transition-colors hover:bg-orange-400"
              >
                去看这些现场
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>

          {/* 右：榜单 */}
          <div className="lg:col-span-8">
            <ol className="space-y-3">
              {hotTopics.map((t) => (
                <li key={t.rank}>
                  <a
                    href="#ranking"
                    className="group flex items-center gap-4 rounded-2xl border border-white/10 bg-white/[0.03] px-4 py-4 transition-colors hover:border-orange-500/40 md:px-5"
                  >
                    <span
                      className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl font-display text-lg font-bold ${rankColor(
                        t.rank
                      )}`}
                    >
                      {t.rank}
                    </span>
                    <div className="min-w-0 flex-1">
                      <h3 className="truncate text-sm font-semibold text-white group-hover:text-orange-200 md:text-base">
                        {t.title}
                      </h3>
                      <span className="mt-1 inline-flex items-center whitespace-nowrap rounded-md bg-white/5 px-2 py-0.5 text-[11px] text-stone-400">
                        {t.tag}
                      </span>
                    </div>
                    <div className="flex shrink-0 flex-col items-end gap-1">
                      <DeltaIcon delta={t.delta} />
                      <span className="whitespace-nowrap font-display text-sm text-stone-300">{t.heat}</span>
                    </div>
                  </a>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}